import "./testimonials.scss";
import "./testimonials.css";
import { SocialIcon } from 'react-social-icons';
export default function Testimonials() {
  const data = [
    {
      id: 1,
      name: "Aditya Kochar",
      title: "First Year Student at DTU",
      img:
        "assets/kochar.jpg",
      desc:
        "Amandeep is a quick learner with an excellent ability to deliver on time.Apart from technical skills,He also have good communication skills with that he make friends very quickly.",
        link: 
        "https://www.linkedin.com/in/aditya-vikram-kochar-b6b159124",
    },
    {
      id: 2,
      name: "Anand Kumar Jha",
      title: "First Year Student at DTU",
      img:
        "assets/anand1.jpg",
      desc:
        "Amandeep is a fast learner, and a hardworking and honest guy.Apart from these ,he is also good at academics and manages every thing quite efficiently",
      featured: true,
      link: 
      "https://www.linkedin.com/in/anand-kumar-jha-33a063170",
    },
    {
      id: 3,
      name: "Sourabh Bansal",
      title: "First Year Student at DTU",
      img:
        "assets/s6.jpg",
      desc:
        "Amandeep is a very genuine and nice guy. He is a true altruist as he helps everyone in problem solving and other study related stuff. He has extraordinary skills in coding and he has achieved it through a lot of hardwork and perserverance.",
        link: 
        "https://www.linkedin.com/in/sourabh-bansal-2901151b9",
    },
  ];
  return (
    <div className="testimonials" id="testimonials">
      <h1>Testimonials</h1>
      <div className="container">
        {data.map((d) => (
          <div className={d.featured ? "card featured" : "card"}>
            <div className="top">
              <img src="assets/right-arrow.png" className="left" alt="" />
              <img
                className="user"
                src={d.img}
                alt=""
              />
              
              
        <SocialIcon style={{width:"30px",height:"30px",position:"relative"}} url={d.link} />

              
            </div>
            <div className="center">
              {d.desc}
            </div>
            <div className="bottom">
              <h3>{d.name}</h3>
              <h4>{d.title}</h4>
            </div>
          </div>
        ))}
        
      </div>
    </div>
  );
}
